import { APP_ID } from '../helpers/constants'

export const getHeaders = (extra = {}) => ({
  'Content-Type': 'application/json',
  appId: APP_ID,
  ...extra,
})

export const API_BASE = process.env.REACT_APP_API_URL
